var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoEnterPayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 21") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-948.000000, -790.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(948.000000, 790.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(14.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,5.31000553 C5.41741656,3.71735986 2.88751618,3.85824359 1.91029885,5.73265674 C0.93308153,7.60706989 2.07663948,8.91845767 5.3409727,9.66682008 C8.67043368,10.7256063 9.67052397,12.1174477 8.34124357,13.8423442 C7.01196316,15.5672408 4.39821531,15.6636412 0.5,14.1315456",
    id: "Path-88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58404541,0.395507812 L5.58404541,19.296875",
    id: "Path-89"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-13-Copy-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,5.31000553 C5.41741656,3.71735986 2.88751618,3.85824359 1.91029885,5.73265674 C0.93308153,7.60706989 2.07663948,8.91845767 5.3409727,9.66682008 C8.67043368,10.7256063 9.67052397,12.1174477 8.34124357,13.8423442 C7.01196316,15.5672408 4.39821531,15.6636412 0.5,14.1315456",
    id: "Path-88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58404541,0.395507812 L5.58404541,19.296875",
    id: "Path-89"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEnterPayment);
export default __webpack_public_path__ + "static/media/ico_enter-payment.ba0441409d9410f115d6c911b1df945b.svg";
export { ForwardRef as ReactComponent };